import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { DashboardData, News } from "src/app/shared/models/dashboard.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { BroshService } from "src/app/shared/services/brosh.service";
import { Store } from "@ngrx/store";
import { dashboardData } from "src/app/shared/ngrx/ngrx-selectors";
import { Subject } from "rxjs";
import { ofType, Actions } from "@ngrx/effects";
import { map, take, takeUntil } from "rxjs/operators";
import { GET_DASHBOARD_DATA } from "src/app/shared/ngrx/ngrx-actions";
import { ModalPopupComponent } from "src/app/shared/components/ui/modal-popup.component";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { EditNewsComponent } from "./edit-news/edit-news.component";

@Component({
  selector: "dash-news",
  templateUrl: "./dash-news.component.html",
  styleUrls: ["./dash-news.component.scss"],
  imports: [
    TranslateModule,
    ModalPopupComponent,
    CommonModule,
    EditNewsComponent,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashNewsComponent implements OnInit {
  allowEdit: boolean;
  curNewsItem: News;
  displayEditNews: boolean;
  destroy$ = new Subject();

  get data(): DashboardData {
    return this.store.selectSignal(dashboardData)();
  }

  constructor(
    private readonly store: Store,
    private actions$: Actions,
    private authService: AuthService,
    private cdr: ChangeDetectorRef
  ) {
    this.allowEdit = this.authService.currentUser.org == "LAB";

    this.actions$
      .pipe(
        ofType(GET_DASHBOARD_DATA),
        takeUntil(this.destroy$),
        map(({}) => {
          console.log(this.data);
          this.setFirstItem();
          this.cdr.markForCheck();
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next(1);
  }

  ngOnInit(): void {
    this.setFirstItem();
  }

  setFirstItem() {
    if (this.data.news && this.data.news.length > 0)
      this.curNewsItem = this.data.news[0];
    else this.curNewsItem = null;
  }

  navNewsClicked(item: News) {
    this.curNewsItem = item;
  }
}
